import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import angularGettext from 'angular-gettext';
import ProductsListPage from './ProductsListPage';
import ProductsFormPage from './ProductsFormPage';

let productsPageModule = angular.module('cms.pages.products', [
    uiRouter,
    angularGettext,
    ProductsListPage,
    ProductsFormPage
])
    .config(routeConfig);

function routeConfig($stateProvider, gettext) {
    /** @ngInject */
    $stateProvider
        .state('products', {
            url: '/products?name&slug&price&status&order_by&order_direction&page',
            component: 'productsListPage',
            title: gettext('Products'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            reloadOnSearch: false,
            sidebarMeta: {
                icon: 'ion-android-cart',
                order: 0,
                allow: ['ROLE_ADMIN']
            }
        })
        .state('productsAdd', {
            url: '/products/add',
            component: 'productsFormPage',
            title: gettext('Add Product'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            params: {
                returnState: null
            },
            breadcrumbsMeta: {
                parentState: 'products'
            }
        })
        .state('productsEdit', {
            url: '/products/edit/:id',
            component: 'productsFormPage',
            params: {
                returnState: null
            },
            title: gettext('Edit Product'),
            data: {
                requiresAuth: ['ROLE_ADMIN']
            },
            breadcrumbsMeta: {
                parentState: 'products'
            }
        })
    ;
}


export default productsPageModule.name;


// WEBPACK FOOTER //
// ./src/cmsPages/Products/ProductsPageModule.js